import { ProductoColaboradorDTO, setListProductoColaborador } from "../ColaboradorProdcutoDTO";
import { TblDecInvMotivoProdTermin, getVoidMotivo, setProductoMotivo } from "../TblDecInvMotivoProdTermin";
import { TblProductoProdTermin, getVoidProdcutoTerminado, setProductoTerminado } from "../TblProductoProdTermin";

export interface AdjuntarProductoDTO{
    producto: TblProductoProdTermin, 
    colProducto: Array<ProductoColaboradorDTO>,
    motivo: TblDecInvMotivoProdTermin,
    idUsuarioAdjun: number
}

export function getVoidAdjuntarProductoDTO(): AdjuntarProductoDTO{
    return{
        producto: getVoidProdcutoTerminado(), 
        colProducto: [],
        motivo: getVoidMotivo(),
        idUsuarioAdjun: 0
    }
}

export function setAdjuntarProductoDTO(data: any): AdjuntarProductoDTO{
    return{
        producto: setProductoTerminado(data.producto) as TblProductoProdTermin,
        motivo: setProductoMotivo(data.motivo) as TblDecInvMotivoProdTermin,
        colProducto: setListProductoColaborador(data.colProducto) as Array<ProductoColaboradorDTO>,
        idUsuarioAdjun: data.idUsuarioAdjun
    }
}